import React from 'react';
import { SvgIcon } from '../components/svgIcon';
import { SvgIconProps } from '../components/svgIcon/model';

export const LikeIcon = React.forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <SvgIcon cacheName="like" ref={ref as any} {...props}>
      <path
        d="M8.33333 18.3333H6.33333C5.97971 18.3333 5.64057 18.1929 5.39052 17.9428C5.14048 17.6928 5 17.3536 5 17V12.3333C5 11.9797 5.14048 11.6406 5.39052 11.3905C5.64057 11.1405 5.97971 11 6.33333 11H8.33333M13 9.66667V7C13 6.46957 12.7893 5.96086 12.4142 5.58579C12.0391 5.21071 11.5304 5 11 5L8.33333 11V18.3333H15.8533C16.1749 18.337 16.4869 18.2243 16.7319 18.016C16.977 17.8077 17.1385 17.5179 17.1867 17.2L18.1067 11.2C18.1357 11.0089 18.1228 10.8138 18.0689 10.6282C18.015 10.4425 17.9214 10.2709 17.7946 10.125C17.6677 9.97916 17.5107 9.86262 17.3344 9.78348C17.158 9.70434 16.9666 9.66448 16.7733 9.66667H13Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </SvgIcon>
  );
});
